import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Wrapper from "components/LayoutFront/Wrapper";
import DSFRSubpageContents from "components/templatesComponents/DSFRSubpageContents";
import Icon from "components/templatesComponents/Icon";
import Link from "components/templatesComponents/Link";
import SeparatorDSFR from "components/templatesComponents/SeparatorDSFR";
import SubPageContext from "components/templatesComponents/SubPageContext";
import PropTypes from "prop-types";
import React, { useContext, useMemo } from "react";

const DSFRSubpage = (props) => {
  const { link = null, title, linkTitle, ...contents } = props;

  const { noSeparator } = useContext(SubPageContext);

  const titleLink = useMemo(() => linkTitle || link.title, [linkTitle, link.title]);

  return (
    <>
      {!noSeparator && <SeparatorDSFR />}
      <Box sx={{ minHeight: "200px" }}>
        <Wrapper>
          <Stack
            direction={{ md: "row" }}
            spacing={2}
            sx={{
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", lg: "center" },
              mt: 2,
              mb: 3,
              "& h2": { flex: 1 },
            }}
          >
            {title && <h2>{title}</h2>}
            {titleLink && (
              <Link
                {...link}
                sx={{ backgroundImage: "none", ml: 3, "&.fr-link[target=_blank]:after": { content: "none" } }}
              >
                {titleLink}
                <Icon iconDSFR="arrow-right-line" size="sm" sx={{ ml: 1 }} />
              </Link>
            )}
          </Stack>
          <DSFRSubpageContents {...contents} />
        </Wrapper>
      </Box>
    </>
  );
};

DSFRSubpage.propTypes = {
  link: PropTypes.shape(),
  title: PropTypes.oneOfType([PropTypes.shape(), PropTypes.string]),
  linkTitle: PropTypes.oneOfType([PropTypes.shape(), PropTypes.string]),
};

export default DSFRSubpage;
